import {  memo  } from 'react';
import List from '@mui/material/List';
import MapListItemHistory from './MapListItemHistory.js';
import {Box} from '@mui/material';

const MapListHistory = memo((props) => {
    const {histories , selectHistory} = props;

    return (
        <div className="leaflet-container">
            <List className="map-list">
                <Box>
                    <MapListItemHistory histories={histories} selectHistory={selectHistory} />     
                </Box>
            </List>
        </div>
    )
});
export default MapListHistory